
import SpeedkitPicture from '#speedkit/components/SpeedkitPicture'

export default {
  name: 'Steps',
  components: { SpeedkitPicture },
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    slug: {
      type: String,
    },
    steps: {
      type: Array,
    },
  },
  computed: {
    stepsSchema() {
      let steps = this.steps.map((step, index) => {
        let instructions = this.$md.render(step.description)

        if (instructions.endsWith('\n')) {
          instructions = instructions.substring(0, instructions.length - 1)
        }

        let image = step.image.data
          ? {
              '@type': 'ImageObject',
              url: step.image.data.attributes.url,
            }
          : ''

        return {
          '@type': 'HowToStep',
          name: step.title,
          url: `https://echowave.io/${this.slug}/#step${index}`,
          itemListElement: {
            '@type': 'HowToDirection',
            text: instructions,
          },
          image: image,
        }
      })

      return {
        '@context': 'http://schema.org',
        '@type': 'HowTo',
        name: this.title,
        description: this.description,
        // "image": {
        //   "@type": "ImageObject",
        //   "url": "https://echowave.io/images/talking.jpg",
        //   "height": "610",
        //   "width": "915"
        // },
        estimatedCost: {
          '@type': 'MonetaryAmount',
          currency: 'USD',
          value: '0',
        },
        supply: [
          {
            '@type': 'HowToSupply',
            name: 'Audio or Video Media File',
          },
        ],
        tool: [
          {
            '@type': 'HowToTool',
            name: 'EchoWave Account',
          },
          {
            '@type': 'HowToTool',
            name: 'PC or Smartphone',
          },
        ],
        step: steps,
        totalTime: `PT${Math.round(this.steps.length * 2.5)}M`,
      }
    },
  },
}
